<template>
  <div>
    <v-layout
      row
      align-center
      :style="myLayoutStyle"
    >
      <v-flex
        xs12
        sm10
        offset-sm1
        md10
        offset-md1
        lg10
        offset-lg1
        xl8
        offset-xl2
      >
        <v-card
          flat
          :color="theme.bg_color"
        >
          <v-card-text>
            <v-layout
              row
              align-center
            >
              <page-title :title="$t('my_sets')" />
            </v-layout>
            <div v-if="customSets && customSets.length > 0">
              <v-card
                v-for="customSet in customSets"
                :key="customSet.id"
                style="border-radius: 5px; margin-bottom: 18px;"
                :color="theme.address_bg_color"
                hover
              >
                <v-card-title class="pb-0">
                  <v-layout row>
                    <v-flex xs8>
                      <h4 :style="cardTitleStyle">{{ customSet.name }}</h4>
                    </v-flex>
                    <v-flex
                      xs4
                      text-xs-right
                    >
                      <div style="margin-top: -9px;">
                        <v-btn
                          icon
                          small
                        >
                          <v-icon
                            small
                            :color="theme.address_text_color"
                            @click="deleteCustomSet(customSet.id)"
                          >fa-trash-alt</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          small
                        >
                          <v-icon
                            small
                            :color="theme.address_text_color"
                            @click="editCustomSet(customSet)"
                          >fas fa-edit</v-icon>
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-title>
                <span v-if="parseItems(customSet.items).length > 0">
                  <v-card-text :style="cardTextStyle">
                    <div
                      v-for="item in parseItems(customSet.items)"
                      :key="item.cart_id"
                    >
                      <v-layout
                        row
                        align-center
                        mb-2
                      >
                        <v-flex
                          xs2
                          sm1
                          md1
                          lg1
                          xl1
                        >
                          <span>{{ item.quantity }}x</span>
                        </v-flex>
                        <v-flex
                          xs10
                          sm11
                          md11
                          lg11
                          xl11
                        >
                          <span>{{ itemName(item) }}</span>
                          <div v-if="courseItems(item)">
                            <ul :style="listStyle">
                              <li
                                v-for="(name, index) in courseItems(item)"
                                :key="index"
                              >{{ name }}</li>
                            </ul>
                          </div>
                          <div v-if="item.remarks">
                            <span class="remarks">{{ $t('remarks') }}: {{ item.remarks }}</span>
                          </div>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-card-text>
                  <v-layout
                    row
                    justify-end
                    class="add-cart-btn"
                  >
                    <v-btn
                      flat
                      small
                      :color="theme.address_text_color"
                      @click="addToCart(customSet.items)"
                    >+ {{ $t('add_to_cart') }}</v-btn>
                  </v-layout>
                </span>
                <v-card-text
                  v-else
                  :style="cardNoneStyle"
                >
                  {{ $t('none') }}
                </v-card-text>
              </v-card>
            </div>
            <div
              v-else
              class="mt-2 mb-2"
              :style="nameStyle"
            >
              {{ $t('none') }}
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-footer
      v-if="customSets && customSets.length < 5"
      fixed
      app
      inset
      :height="theme.footer_height"
      :color="theme.footer_bg_color"
    >
      <v-btn
        block
        dark
        large
        class="btn"
        :color="theme.btn_color_primary"
      >
        <v-layout row>
          <v-flex
            xs12
            class="text-xs-center"
            @click="addCustomSet"
          >
            {{ $t('add') }}
          </v-flex>
        </v-layout>
      </v-btn>
    </v-footer>
    <v-dialog
      v-model="dialog"
      persistent
      fullscreen
    >
      <v-card :color="theme.login_bg_color">
        <v-card-text class="pa-4">
          <form
            @submit.prevent="saveCustomSet"
            @keydown="form.onKeydown($event)"
          >
            <v-layout row>
              <v-flex
                xs12
                sm10
                offset-sm1
                md8
                offset-md2
                lg6
                offset-lg3
                xl6
                offset-xl3
              >
                <v-layout
                  row
                  align-center
                >
                  <v-flex xs12>
                    <span class="main-title">{{ dialogCustomSetId ? $t('edit_custom_set') : $t('add_custom_set') }}</span>
                  </v-flex>
                </v-layout>
                <div class="mt-2">
                  <v-text-field
                    v-model="form.name"
                    ref="nameField"
                    name="name"
                    label="Name"
                    :color="theme.btn_color_secondary"
                    outline
                    :error-messages="errors.collect('name')"
                    v-validate="'required|max:25'"
                  ></v-text-field>
                  <v-layout
                    row
                    align-center
                    class="mt-3"
                  >
                    <v-flex xs5>
                      <span class="main-title">{{ $t('custom_set_items') }}</span>
                    </v-flex>
                    <v-flex
                      xs7
                      text-xs-right
                    >
                      <v-btn
                        flat
                        small
                        :color="theme.btn_color_secondary"
                        :disabled="customSetItems.length > 8"
                        @click="openAddItemDialog"
                      >
                        + {{ $t('add_item') }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <div v-if="customSetItems.length > 0">
                    <div
                      v-for="item in customSetItems"
                      :key="item.cart_id"
                      class="mt-2"
                    >
                      <v-layout
                        row
                        align-center
                        mb-2
                      >
                        <v-flex
                          xs2
                          sm1
                          md1
                          lg1
                          xl1
                        >
                          <div style="text-align: center;">
                            <span>{{ item.quantity }}x</span>
                          </div>
                          <div style="text-align: center; margin-top: -10px;">
                            <v-btn
                              icon
                              small
                              @click="removeItem(item)"
                            >
                              <v-icon
                                small
                                :color="theme.trashcan_color"
                              >fa-trash-alt</v-icon>
                            </v-btn>
                          </div>
                        </v-flex>
                        <v-flex
                          xs9
                          sm10
                          md10
                          lg10
                          xl10
                        >
                          <span>{{ itemName(item) }}</span>
                          <div v-if="courseItems(item)">
                            <ul :style="listStyle">
                              <li
                                v-for="(name, index) in courseItems(item)"
                                :key="index"
                              >{{ name }}</li>
                            </ul>
                          </div>
                          <div v-if="item.remarks">
                            <span class="remarks">{{ $t('remarks') }}: {{ item.remarks }}</span>
                          </div>
                        </v-flex>
                        <v-flex
                          xs2
                          sm1
                          md1
                          lg1
                          xl1
                        >
                          <div style="text-align: center;">
                            <v-btn
                              icon
                              small
                              @click="editItem(item)"
                            >
                              <v-icon
                                small
                                :color="theme.trashcan_color"
                              >fas fa-edit</v-icon>
                            </v-btn>
                          </div>
                        </v-flex>
                      </v-layout>
                      <v-divider />
                    </div>
                  </div>
                  <div
                    v-else
                    class="mt-2 mb-2"
                    :style="nameStyle"
                  >
                    {{ $t('none') }}
                  </div>
                </div>
                <div class="mt-3 text-xs-center">
                  <v-btn
                    dark
                    :color="theme.btn_color_secondary"
                    type="submit"
                  >
                    {{ $t('save') }}
                  </v-btn>
                  <v-btn
                    flat
                    :color="theme.btn_color_secondary"
                    @click="dialog = false"
                  >
                    {{ $t('close') }}
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </form>
        </v-card-text>
      </v-card>
      <cart-item-dialog v-if="cartItemDialog" from-custom-sets @update-item="updateItem" />
      <cat-list-dialog v-if="catListDialog" @add-item="addItem" />
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import Form from 'vform'
import { mapGetters } from 'vuex'
import PageTitle from '~/components/PageTitle'
import CatListDialog from '~/components/CatListDialog'
import CartItemDialog from '~/components/CartItemDialog'

export default {
  name: 'custom-sets-view',
  metaInfo () {
    return { title: "Custom Sets" }
  },
  components: {
    'page-title': PageTitle,
    'cat-list-dialog': CatListDialog,
    'cart-item-dialog': CartItemDialog
  },
  data: () => ({
    dialog: false,
    dialogCustomSetId: null,
    customSetItems: [],
    form: new Form({
      name: ''
    }),
  }),
  computed: {
    ...mapGetters('config', [
      'theme', 'language', 'iOS', 'inIframe'
    ]),
    ...mapGetters('auth',[
      'authMsg', 'customSets'
    ]),
    ...mapGetters('menu',[
      'catList', 'catListDialog', 'items'
    ]),
    ...mapGetters('cart',[
      'cartItemDialog'
    ]),
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    nameStyle () {
      return {
        color: this.theme.orders_name_color
      }
    },
    cardTitleStyle () {
      return {
        color: this.theme.address_text_color,
        fontWeight: 800,
        textTransform: 'capitalize'
      }
    },
    cardTextStyle () {
      return {
        paddingTop: '0',
        paddingBottom: '0',
        color: this.theme.address_text_color
      }
    },
    cardNoneStyle () {
      return {
        paddingTop: '0',
        paddingBottom: '10px',
        color: this.theme.address_text_color,
        fontSize: '14px'
      }
    },
    listStyle () {
      return {
        listStyleType: 'none',
        paddingLeft: '0',
        fontSize: '15px'
      }
    },
    addItemStyle () {
      return {
        border: `1px solid ${this.theme.address_text_color}`
      }
    }
  },
  methods: {
    parseItems (items) {
      let items2
      try {
        items2 = JSON.parse(items)
      } catch (e) {
        items2 = []
      }
      return items2
    },
    async parseItemsAndFilter (items) {
      items = this.parseItems(items)

      let result = [];
      for (let i = 0; i < items.length; i++) {
        let item = items[i]
        const key = 'c' + item.category_id
        if (!this.items[key]) {
          await this.$store.dispatch('fetchCatItems', item.category_id)
        }

        let categoryItems = this.items[key]

        if (!categoryItems.length) {
          continue;
        }

        for (let j = 0; j < categoryItems.length; j++) {
          let categoryItem = categoryItems[j]

          if (
            categoryItem.item_id === item.item_id
            && categoryItem.plu_id === item.plu_id
          ) {
            const newSetCoursesItems = []
            for (let k = 0; k < item.set_course_items.length; k++) {
              let setCourseItem = item.set_course_items[k]
              for (let n = 0; n < categoryItem.courses.length; n++) {
                let categoryItemCourses = categoryItem.courses[n];
                for (let m = 0; m < categoryItemCourses.course_items.length; m++) {
                  let categoryItemCourseItem = categoryItemCourses.course_items[m]
                  if (
                    categoryItemCourseItem.course_item_id == setCourseItem.setCourseItemID
                    && categoryItemCourseItem.plu_id == setCourseItem.plu_id
                  ) {
                    categoryItemCourses.selected = categoryItemCourseItem.item_id
                    let newSetCourseItem = {
                      item_id: categoryItemCourseItem.course_item_id,
                      name: categoryItemCourseItem.name,
                      plu_id: categoryItemCourseItem.plu_id,
                      price: categoryItemCourseItem.price,
                      price_override: categoryItemCourseItem.price_override,
                      priceow: categoryItemCourseItem.price_override,
                      quantity: 1,
                      qty: 1, // Accepted by POS
                      tax: categoryItemCourseItem.tax,
                      pluID: categoryItemCourseItem.plu_id, // Accepted by POS
                      setCourseItemID: categoryItemCourseItem.course_item_id, // Accepted by POS
                      service_charge: categoryItemCourseItem.service_charge,
                      time_required: categoryItemCourseItem.time_required,
                      tray_count: categoryItemCourseItem.tray_count,
                      is_set_meal: categoryItemCourseItem.is_set_meal,
                      non_discount: categoryItemCourseItem.non_discount,
                      photo_url: categoryItemCourseItem.photo_url,
                      courseLevel: categoryItemCourseItem.level || 0,
                      isItemSetMeal: categoryItemCourseItem.isItemSetMeal || 0,
                      alternativeName: categoryItemCourseItem.name,
                    }

                    newSetCoursesItems.push(newSetCourseItem)
                  }
                }
              }
            }

            if (newSetCoursesItems.length !== item.set_course_items.length) {
              continue;
            }

            let itemResult = {
              voucher_id: null,
              member_voucher_id: null,
              item_id: categoryItem.item_id,
              category_id: categoryItem.category_id,
              category_name:categoryItem.category_name,
              category_alternate_name:categoryItem.category_alternate_name,
              name: categoryItem.name,
              alternativeName: categoryItem.alternate_name,
              portion_size_name: categoryItem.portion_size_name,
              priceText: categoryItem.price_text,
              plu_id: categoryItem.plu_id,
              price: categoryItem.price,
              price_override: categoryItem.price_override || null,
              quantity: item.quantity,
              final_price: categoryItem.price, // item.final_price || categoryItem.price
              tax: categoryItem.tax,
              service_charge: categoryItem.service_charge,
              remarks: item.remarks, // item.special_req || null,
              time_required: categoryItem.time_required || 0,
              tray_count: categoryItem.tray_count,
              modifiers: item.options.concat(item.toppings),
              options: item.options,
              toppings: item.toppings,
              is_set_meal: categoryItem.is_set_meal,
              set_course_items: newSetCoursesItems,
              non_discount: categoryItem.non_discount,
              photo_url: categoryItem.photo_url,
              courses: categoryItem.courses,
              option_groups: categoryItem.option_groups,
              max_quantity: categoryItem.max_quantity || 10,
              min_quantity: categoryItem.min_quantity || 1
            }

            result.push(itemResult)
          }
        }
      }

      console.log(items, result)

      return result;
    },
    itemName (item) {
      if (this.language !== 'en-SG') {
        return item.alternativeName || item.name
      }
      return item.name
    },
    courseItems (item) {
      if (item.set_course_items.length > 0) {
        if (this.language !== 'en-SG') {
          return item.set_course_items.map(item => item.alternativeName || item.name)
        }
        return item.set_course_items.map(item => item.name)
      }
      return null
    },
    addCustomSet () {
      this.dialogCustomSetId = null
      this.form.name = ''
      this.customSetItems = []
      this.dialog = true
    },
    editCustomSet (customSet) {
      this.dialogCustomSetId = customSet.id
      this.form.name = customSet.name
      this.customSetItems = this.parseItems(customSet.items)
      this.dialog = true
    },
    async saveCustomSet () {
      if (await this.formHasErrors()) return
      this.$bus.$emit('showFullLoading', true)
      // JSON stringify here, as PHP converts some empty string to null that causes differences when comparing
      if (!this.dialogCustomSetId) {
        await this.$store.dispatch('auth/addCustomSet', {
          name: this.form.name,
          items: JSON.stringify(this.customSetItems)
        })
      } else {
        await this.$store.dispatch('auth/editCustomSet', {
          id: this.dialogCustomSetId,
          name: this.form.name,
          items: JSON.stringify(this.customSetItems)
        })
      }
      this.$bus.$emit('showFullLoading', false)
      if (this.authMsg) {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: this.$t('custom_set_saved_title'),
          text: this.$t(this.authMsg),
          modal: true
        })
      } else {
        this.dialog = false
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('custom_set_saved_success_notice')
        })
      }
    },
    deleteCustomSet (id) {
      this.$store.dispatch('responseMessage', {
        type: 'error',
        title: this.$t('custom_set_saved_title'),
        text: this.$t('custom_set_deleted_confirmation'),
        btn3: { text: 'Ok', function: 'deleteCustomSet2', param: id },
        modal: true
      })
    },
    async deleteCustomSet2 (id) {
      this.$bus.$emit('showFullLoading', true)
      await this.$store.dispatch('auth/deleteCustomSet', id)
      this.$bus.$emit('showFullLoading', false)
      if (this.authMsg) {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: this.$t('custom_set_saved_title'),
          text: this.$t('custom_set_deleted_fail_notice'),
          modal: true
        })
      } else {
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('custom_set_deleted_success_notice')
        })
      }
    },
    openAddItemDialog () {
      this.$store.dispatch('menu/showCatListDialog')
    },
    editItem (item) {
      this.$store.dispatch('cart/showCartItemDialog', item)
      if (this.iOS && this.inIframe) {
        this.$router.push({ name: 'cart_item', params: { return: 'cart' }})
      }
    },
    updateItem (item) {
      console.log(item)
      this.$store.dispatch('cart/hideCartItemDialog')
      const i = this.customSetItems.findIndex(i => (parseInt(i.item_id) === parseInt(item.item.item_id)) &&
        (_.isEqual(_.omit(i, ['quantity']), _.omit(item.item, ['quantity'])) === true))
      if (i === -1) return
      const options = item.options ? item.options : []
      const toppings = item.toppings ? item.toppings : []
      this.customSetItems[i] = {
        ...item.item,
        quantity: item.quantity,
        final_price: item.final_price ? item.final_price : item.item.price,
        remarks: item.special_req ? item.special_req : null,
        modifiers: options.concat(toppings),
        options: options,
        toppings: toppings,
        set_course_items: item.set_course_items ? item.set_course_items : []
      }
    },
    removeItem (item) {
      this.customSetItems = this.customSetItems.filter(i => i !== item)
    },
    addItem (item) {
      const i = this.customSetItems.findIndex(i => (parseInt(i.item_id) === parseInt(item.item_id)) &&
        (_.isEqual(_.omit(i, ['quantity']), _.omit(item, ['quantity'])) === true))
      if (i === -1) {
        this.customSetItems.push(item)
      } else {
        const qty = this.customSetItems[i].quantity + item.quantity
        Vue.set(this.customSetItems, i, Object.assign({}, this.customSetItems[i], {
          quantity: qty
        }))
      }
      this.$store.dispatch('menu/hideMenuItemDialog')
      this.$store.dispatch('menu/hideCatListDialog')
    },
    async addToCart (items) {
      this.$bus.$emit('showFullLoading', true)
      let filteredItems = await this.parseItemsAndFilter(items);
      if (filteredItems.length) {
        this.$store.dispatch('cart/addMultipleCartItems', filteredItems)
      }

      let jsonDecodedItems = JSON.parse(items)
      if (!filteredItems.length) {
        this.$store.dispatch('responseMessage', {
          type: 'warning',
          text: this.$t('Item addition failed, no items available')
        })
      } else if (jsonDecodedItems.length !== filteredItems.length) {
        this.$store.dispatch('responseMessage', {
          type: 'warning',
          text: this.$t('some_items_is_not_available_available_items_added_successfully')
        })
      } else {
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('successfully_added_item')
        })
      }

      this.$bus.$emit('showFullLoading', false)
    }
  },
  beforeMount () {
    const vm = this
    this.$bus.$on('deleteCustomSet2', (payload) => {
      vm.deleteCustomSet2(payload)
    })
  },
  async created () {
    this.$bus.$emit('showFullLoading', true)
    await this.$store.dispatch('auth/fetchCustomSets')
    this.$bus.$emit('showFullLoading', false)
  },
  beforeDestroy () {
    this.$bus.$off('deleteCustomSet2')
  }
}
</script>

<style scoped>
.main-title {
  font-weight: 800;
}
.btn {
  margin: 10px;
  padding: 0 16px;
}
.remarks {
  font-size: 13px;
}
.add-cart-btn {
  margin-top: -13px;
}
</style>



// WEBPACK FOOTER //
// src/pages/custom_sets.vue